<template>
	<div class="laser-details-content">
		<Accordion title="Prompt Order Details" v-model="accordion.first">
			<template #body-content>
				<div class="prompt-order-details">
					<span v-if="!hasResults">No Input Fields Added</span>
					<ul class="prompt-order__list">
						<li
							class="prompt-order__list-item"
							v-for="detail in inputFields"
							:key="detail.value"
						>
							<div class="prompt-order__list-item-name">
								<span class="laser-details-title">
									Field Name
								</span>
								<p class="laser-details-text">
									{{ detail.keyboardPrompt }}
								</p>
							</div>

							<div class="prompt-order__list-item-prompt">
								<span class="laser-details-title"
									>Prompt Order</span
								>
								<p class="laser-details-text">
									{{ detail.order }}
								</p>
							</div>

							<div class="prompt-order__list-item-id">
								<span class="laser-details-title"
									>SQL ID:
									<span class="laser-details-text">{{
										detail.id
									}}</span></span
								>
							</div>
						</li>
					</ul>
				</div>
			</template>
		</Accordion>
		<!-- </div> -->
	</div>
</template>

<script>
import Accordion from '@/components/shells/accordion/accordion';

export default {
	name: 'LaserDetailsContent',
	components: {
		Accordion
	},
	model: {
		prop: 'inputFields'
	},
	props: {
		inputFields: {
			type: Array,
			default: () => []
		}
	},
	computed: {
		hasResults() {
			return this.inputFields.length > 0;
		}
	},
	data() {
		return {
			accordion: {
				first: true
			}
		};
	}
};
</script>

<style lang="scss">
/**
  * Laser Form details
  * Can use SCSS variables = TRUE
*/

/*------------------------------------*\
  ACCORDIONS
\*------------------------------------*/

.laser-details-content {
	background: $white;
	padding: $padding-md $padding-sm;
	@include mq($until: sm-l) {
		margin-left: -8px;
		margin-right: -8px;
		border-top: 1px solid $neutral-3;
	}

	@include mq($from: sm-l) {
		padding: 0;
	}

	@include mq($from: md) {
		border: none;
		padding: 0;
	}
}

.laser-details-title {
	display: block;
	font-weight: $medium-font-weight;
	font-size: $label-font-size;
	margin-bottom: $gutter-sm;
	color: inherit;
}

.laser-details-text {
	font-size: 14px;
}

.prompt-order-details {
	padding: $padding-md;
}

.prompt-order__list {
	max-height: 120px;
	overflow: auto;
	@include scrollbar;

	@include mq($from: md) {
		max-width: 65%;
		max-height: 320px;
	}

	@include mq($from: lg) {
		max-width: 50%;
		max-height: 520px;
	}

	&-item {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		border: 1px solid $neutral-3;
		border-radius: $card-border-radius;
		margin-top: $gutter-lg;
		padding: $padding-md;
		padding-bottom: $padding-sm;

		&:first-child {
			margin-top: 0;
		}

		&-name,
		&-prompt {
			width: 50%;
		}

		&-name,
		&-prompt,
		&-id {
			.laser-details-title {
				margin-top: 0;
				margin-bottom: $gutter-md;
			}
		}

		&-id {
			margin-top: $gutter-lg;
			> .laser-details-title > span {
				font-weight: initial;
			}
		}
	}

	@include mq($from: lg) {
		&-item {
			justify-content: space-between;
			padding-bottom: $padding-md;

			&-name,
			&-prompt {
				width: initial;
			}

			&-id {
				margin-top: 0;
			}
		}
	}
}

.form-info-items {
	display: flex;
	flex-wrap: wrap;
	margin-bottom: $gutter-xl;

	@include mq($from: lg) {
		gap: $gutter-xl;
	}

	&__name,
	&__revision,
	&__description {
		min-width: 100%;

		.laser-details-title {
			margin-bottom: $gutter-md;
		}
	}

	&__name,
	&__revision {
		@include mq($from: md) {
			min-width: 49%;
		}

		@include mq($from: lg) {
			min-width: 20%;
		}
	}

	&__description {
		@include mq($from: lg) {
			min-width: 56%;
			max-width: 56%;
		}
	}
}
</style>
